module.exports = __webpack_public_path__ + "img/BusinessCenterOutlined.1fffbd79.svg";